import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "hidden lg:block overflow-x-auto max-h-[600px] overflow-y-auto" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 sticky top-0 z-10" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_9 = { class: "px-6 py-5 whitespace-nowrap" }
const _hoisted_10 = { class: "font-semibold text-slate-900" }
const _hoisted_11 = { class: "px-6 py-4 font-semibold text-slate-900" }
const _hoisted_12 = { class: "px-6 py-4 text-slate-600" }
const _hoisted_13 = { class: "px-6 py-4 text-slate-600" }
const _hoisted_14 = { class: "px-6 py-4 text-slate-600" }
const _hoisted_15 = { class: "px-6 py-4 text-slate-800 font-medium" }
const _hoisted_16 = { class: "px-6 py-4 text-slate-700" }
const _hoisted_17 = { class: "px-6 py-4" }
const _hoisted_18 = { class: "px-6 py-4 text-sm text-slate-600" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap flex gap-2" }
const _hoisted_20 = ["onClick", "disabled", "title"]
const _hoisted_21 = {
  key: 1,
  class: "w-5 h-5 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_22 = ["onClick", "title"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "mt-5 lg:hidden space-y-4 max-h-[600px] overflow-y-auto px-4" }
const _hoisted_26 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-3 border-b border-slate-200" }
const _hoisted_27 = { class: "flex items-start justify-between gap-3" }
const _hoisted_28 = { class: "flex items-start justify-between gap-3" }
const _hoisted_29 = { class: "flex-shrink-0 w-8 h-8 flex items-center justify-center bg-slate-200 rounded-full font-bold text-slate-700 text-sm" }
const _hoisted_30 = { class: "flex-1 min-w-0" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = { class: "font-bold text-slate-900 text-base truncate" }
const _hoisted_33 = { class: "text-xs text-slate-500 mt-1 flex items-center gap-1" }
const _hoisted_34 = { class: "px-4 py-3 space-y-3" }
const _hoisted_35 = { class: "text-sm text-slate-700 mt-1 line-clamp-3" }
const _hoisted_36 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_37 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_38 = { class: "text-sm text-slate-800 font-medium mt-1" }
const _hoisted_39 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_40 = { class: "text-sm text-slate-800 font-medium mt-1" }
const _hoisted_41 = { class: "flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg" }
const _hoisted_42 = { class: "grid grid-cols-2 gap-2 pt-2 sm:grid-cols-4" }
const _hoisted_43 = ["onClick", "disabled"]
const _hoisted_44 = {
  key: 1,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "fixed bg-black bg-opacity-50 backdrop-blur-sm inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_49 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_50 = { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all w-full max-w-lg" }
const _hoisted_51 = { class: "px-6 py-4" }
const _hoisted_52 = { class: "text-sm text-slate-600 text-center mb-4" }
const _hoisted_53 = { class: "font-semibold text-slate-900" }
const _hoisted_54 = { class: "bg-slate-50 px-6 py-4 flex flex-col-reverse sm:flex-row gap-3" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 1,
  class: "flex items-center justify-center gap-2"
}

import { ref, watch } from "vue";
import AdminToggleSwitch from "@/share/components/admin/AdminToggleSwitch.vue";
import type { Producto } from "../../interfaces/productoInterfaces/Producto.interface";

interface Props {
  productos: Producto[];
  sortField: string | null;
  sortDirection: "asc" | "desc";
  isDelete?: boolean;
  currentPage?: number;
  pageSize?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductoTable',
  props: {
    productos: {},
    sortField: {},
    sortDirection: {},
    isDelete: { type: Boolean },
    currentPage: { default: 1 },
    pageSize: { default: 10 }
  },
  emits: ["sort", "toggleVisibility", "toggleDestacado", "openPromocionModal", "editProducto", "deleteProducto"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Calcular el índice base según la página actual
const getGlobalIndex = (localIndex: number) => {
  return (props.currentPage - 1) * props.pageSize + localIndex + 1;
};

const showDeleteModal = ref(false);
const productoToDelete = ref<{ id: string; nombre: string } | null>(null);
const isDeleting = ref(false);
const togglingDestacado = ref<string | null>(null);

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

const formatCurrency = (value: string) =>
  new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency: "PEN",
  }).format(parseFloat(value));

const toggleVisibility = async (productoId: string) => {
  const producto = props.productos.find((p) => p.id === productoId);
  if (!producto) return;
  producto.isVisible = producto.isVisible === 1 ? 0 : 1;
  await new Promise((resolve) => setTimeout(resolve, 100));
  emit("toggleVisibility", productoId);
};

const getVisibilidadText = (isVisible: number) => {
  return isVisible === 1 ? "Visible" : "Oculto";
};

const toggleDestacado = async (productoId: string) => {
  const producto = props.productos.find((p) => p.id === productoId);
  if (!producto) return;

  togglingDestacado.value = productoId;
  producto.isDestacado = producto.isDestacado === 1 ? 0 : 1;

  await new Promise((resolve) => setTimeout(resolve, 500));
  emit("toggleDestacado", productoId);

  setTimeout(() => {
    togglingDestacado.value = null;
  }, 300);
};

const openDeleteModal = (id: string, nombre: string) => {
  productoToDelete.value = { id, nombre };
  showDeleteModal.value = true;
};

const closeDeleteModal = () => {
  showDeleteModal.value = false;
  productoToDelete.value = null;
};

const confirmDelete = () => {
  if (!productoToDelete.value || isDeleting.value) return;
  isDeleting.value = true;
  emit("deleteProducto", productoToDelete.value.id);
};

watch(
  () => props.isDelete,
  (newVal) => {
    if (newVal) {
      showDeleteModal.value = false;
      productoToDelete.value = null;
      isDeleting.value = false;
    }
  }
);

const getSortIcon = (field: string) => {
  if (props.sortField !== field) {
    return "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4";
  }
  return props.sortDirection === "asc"
    ? "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    : "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", null, [
            _cache[2] || (_cache[2] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xl font-bold text-slate-800 uppercase tracking-wider" }, " # ", -1)),
            _createElementVNode("th", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', 'nombreProducto'))),
              class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer hover:bg-slate-200"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Producto", -1)),
                (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: getSortIcon('nombreProducto')
                  }, null, 8, _hoisted_7)
                ]))
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Marca ", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Categoría ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " proveedor ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Precio ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Stock ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Visibilidad ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Creado ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase" }, " Acciones ", -1))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productos, (producto, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: producto.id,
              class: "hover:bg-slate-50 transition-colors"
            }, [
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(getGlobalIndex(index)), 1)
              ]),
              _createElementVNode("td", _hoisted_11, _toDisplayString(producto.nombreProducto), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(producto.marca?.nombreMarca), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(producto.categoria?.nombreCategoria), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(producto.proveedor?.nombreProveedor), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(formatCurrency(producto.precioProducto)), 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(producto.stockProducto), 1),
              _createElementVNode("td", _hoisted_17, [
                _createVNode(AdminToggleSwitch, {
                  "model-value": producto.isVisible === 1,
                  color: "red",
                  "switch-id": 'prod-vis-desktop-' + producto.id,
                  onToggle: ($event: any) => (toggleVisibility(producto.id))
                }, null, 8, ["model-value", "switch-id", "onToggle"])
              ]),
              _createElementVNode("td", _hoisted_18, _toDisplayString(formatDate(producto.createdAt)), 1),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (toggleDestacado(producto.id)),
                  disabled: togglingDestacado.value === producto.id,
                  class: _normalizeClass(["relative p-1 rounded-lg transition-all duration-300 group", 
                  producto.isDestacado === 1
                    ? 'bg-amber-100 text-amber-500 hover:bg-amber-100'
                    : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                ]),
                  title: 
                  producto.isDestacado === 1 ? 'Destacado' : 'No destacado'
                
                }, [
                  (togglingDestacado.value !== producto.id)
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        class: _normalizeClass(["w-5 h-5 transition-transform group-hover:scale-110", producto.isDestacado === 1 ? 'animate-pulse' : '']),
                        fill: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("path", { d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" }, null, -1)
                      ]))], 2))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ]))]))
                ], 10, _hoisted_20),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (emit('openPromocionModal', producto.id)),
                  class: _normalizeClass(["relative rounded-lg p-1 transition-all duration-300 group", 
                  (producto.isPromocion ?? 0) === 1
                    ? 'bg-orange-100 text-orange-600 hover:bg-orange-100'
                    : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
                ]),
                  title: 
                  (producto.isPromocion ?? 0) === 1
                    ? 'Editar promoción (inicio)'
                    : 'Configurar promoción (inicio)'
                
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["w-5 h-5 transition-transform group-hover:scale-110", (producto.isPromocion ?? 0) === 1 ? 'animate-pulse' : '']),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                    }, null, -1)
                  ]))], 2))
                ], 10, _hoisted_22),
                _createElementVNode("button", {
                  onClick: ($event: any) => (emit('editProducto', producto.id)),
                  class: "p-2 text-blue-600 hover:bg-blue-50 rounded-lg"
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("svg", {
                    class: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 \n                    2.828L11.828 15H9v-2.828l8.586-8.586z"
                    })
                  ], -1)
                ]))], 8, _hoisted_23),
                _createElementVNode("button", {
                  onClick: ($event: any) => (openDeleteModal(producto.id, producto.nombreProducto)),
                  class: "p-2 text-red-600 hover:bg-red-50 rounded-lg"
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("svg", {
                    class: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M19 7l-.867 12.142A2 2 0 0116.138 \n                    21H7.862a2 2 0 01-1.995-1.858L5 \n                    7m5 4v6m4-6v6m1-10V4a1 \n                    1 0 00-1-1h-4a1 1 0 00-1 \n                    1v3M4 7h16"
                    })
                  ], -1)
                ]))], 8, _hoisted_24)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productos, (producto, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: producto.id,
          class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(getGlobalIndex(index)), 1),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("h3", _hoisted_32, _toDisplayString(producto.nombreProducto), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, [
                    _cache[16] || (_cache[16] = _createElementVNode("svg", {
                      class: "w-3 h-3",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(formatDate(producto.createdAt)), 1)
                  ])
                ])
              ]),
              _createVNode(AdminToggleSwitch, {
                "model-value": producto.isVisible === 1,
                color: "red",
                "switch-id": 'prod-vis-mobile-' + producto.id,
                onToggle: ($event: any) => (toggleVisibility(producto.id))
              }, null, 8, ["model-value", "switch-id", "onToggle"])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wide" }, "Descripción", -1)),
              _createElementVNode("p", _hoisted_35, _toDisplayString(producto.descripcionProducto || "Sin descripción"), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Precio", -1)),
                _createElementVNode("p", _hoisted_38, " S/ " + _toDisplayString(producto.precioProducto), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Stock", -1)),
                _createElementVNode("p", _hoisted_40, _toDisplayString(producto.stockProducto), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase" }, "Estado", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium", 
                producto.isVisible === 1
                  ? 'bg-red-100 text-red-700'
                  : 'bg-slate-100 text-slate-700'
              ])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["w-1.5 h-1.5 rounded-full", 
                  producto.isVisible === 1 ? 'bg-red-600' : 'bg-slate-500'
                ])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(getVisibilidadText(producto.isVisible)), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                onClick: ($event: any) => (toggleDestacado(producto.id)),
                disabled: togglingDestacado.value === producto.id,
                class: _normalizeClass(["flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg transition-all font-medium text-sm", 
                producto.isDestacado === 1
                  ? 'bg-amber-50 text-amber-700 hover:bg-amber-100'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
              ])
              }, [
                (togglingDestacado.value !== producto.id)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 0,
                      class: _normalizeClass(["w-4 h-4", producto.isDestacado === 1 ? 'animate-pulse' : '']),
                      fill: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("path", { d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" }, null, -1)
                    ]))], 2))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_44, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))]))
              ], 10, _hoisted_43),
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (emit('openPromocionModal', producto.id)),
                class: _normalizeClass(["flex items-center justify-center gap-2 rounded-lg px-3 py-2.5 text-sm font-medium transition-all", 
                (producto.isPromocion ?? 0) === 1
                  ? 'bg-orange-50 text-orange-700 hover:bg-orange-100'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
              ])
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["h-4 w-4", (producto.isPromocion ?? 0) === 1 ? 'animate-pulse' : '']),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                  }, null, -1)
                ]))], 2))
              ], 10, _hoisted_45),
              _createElementVNode("button", {
                onClick: ($event: any) => (emit('editProducto', producto.id)),
                class: "flex items-center justify-center gap-2 px-3 py-2.5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-colors font-medium text-sm"
              }, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  })
                ], -1)
              ]))], 8, _hoisted_46),
              _createElementVNode("button", {
                onClick: ($event: any) => (openDeleteModal(producto.id, producto.nombreProducto)),
                class: "flex items-center justify-center gap-2 px-3 py-2.5 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors font-medium text-sm"
              }, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  })
                ], -1)
              ]))], 8, _hoisted_47)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (showDeleteModal.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity",
                onClick: closeDeleteModal
              }),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "bg-gradient-to-br from-red-50 to-rose-50 px-6 pt-6 pb-4" }, [
                    _createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 mx-auto bg-red-100 rounded-full" }, [
                      _createElementVNode("svg", {
                        class: "w-8 h-8 text-red-600",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        })
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_51, [
                    _cache[27] || (_cache[27] = _createElementVNode("h3", {
                      class: "text-xl font-bold text-slate-900 text-center mb-2",
                      id: "modal-title"
                    }, " ¿Eliminar Producto? ", -1)),
                    _createElementVNode("p", _hoisted_52, [
                      _cache[26] || (_cache[26] = _createTextVNode(" Estás a punto de eliminar el producto ", -1)),
                      _createElementVNode("span", _hoisted_53, " \"" + _toDisplayString(productoToDelete.value?.nombre) + "\" ", 1)
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "bg-amber-50 border-l-4 border-amber-400 p-4 rounded" }, [
                      _createElementVNode("div", { class: "flex gap-3" }, [
                        _createElementVNode("svg", {
                          class: "w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          })
                        ]),
                        _createElementVNode("p", { class: "text-sm text-amber-800" }, " Esta acción no se puede deshacer. Los productos asociados a esta categoría podrían verse afectados. ")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: closeDeleteModal,
                      class: "flex-1 px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2"
                    }, " Cancelar "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: confirmDelete,
                      disabled: isDeleting.value,
                      class: _normalizeClass(["flex-1 px-4 py-2.5 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 shadow-sm", {
                  'bg-red-600 text-white hover:bg-red-700': !isDeleting.value,
                  'bg-red-400 text-white opacity-70 cursor-not-allowed':
                    isDeleting.value,
                }])
                    }, [
                      (!isDeleting.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Sí, eliminar"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_57, [...(_cache[29] || (_cache[29] = [
                            _createElementVNode("svg", {
                              class: "animate-spin w-4 h-4 text-white",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l3 3-3 3v-4a8 8 0 01-8-8z"
                              })
                            ], -1),
                            _createTextVNode(" Eliminando... ", -1)
                          ]))]))
                    ], 10, _hoisted_55)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})